export const FAQS = [
  { q: "What's the fabric quality?", a: "240 GSM premium combed cotton, pre-shrunk and bio-washed for that lived-in feel." },
  { q: "How long does delivery take?", a: "3-6 business days across India. Free shipping on every order. COD available." },
  { q: "What's your return policy?", a: "Easy 7-day returns. Just keep tags intact. Refund processed within 5 business days." },
  { q: "How does the size run?", a: "We run true-to-size, oversized fits run 1 size larger. Refer to the size guide above." },
];

export const REVIEWS = [
  { name: "Vikram J.", rating: 5, body: "Quality is unreal at this price. Already ordered my 4th tee.", img: "https://images.pexels.com/photos/19101424/pexels-photo-19101424.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=300&w=300" },
  { name: "Sneha P.", rating: 5, body: "Fits like a dream and the print quality is sharp. Delivery was fast.", img: "https://images.pexels.com/photos/9637851/pexels-photo-9637851.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=300&w=300" },
  { name: "Rohan T.", rating: 4, body: "Heavy fabric, drops perfectly. Anime print is fire.", img: "https://images.pexels.com/photos/28758240/pexels-photo-28758240.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=300&w=300" },
];

export const colorImageKey = (colorImages, color) => (
  Object.keys(colorImages || {}).find((key) => key.toLowerCase() === String(color || "").toLowerCase())
);
